/* Tonight's Sacrifice. Screaming Saints, from October 2026, all year.
 * One horror film for tonight, drawn as a tarot card. The core at the top is
 * pure (no DOM) and is what test/sstonight.test.mjs exercises; the page code
 * below it only runs in a browser.
 * Films come from ss-31-nights-films.json (shared with 31 Nights: `n` never
 * changes). Facts from ss-tonight-facts.json: every fact carries a source and
 * nothing unsourced is shown. The house card for each date comes from
 * ss-tonight-daily.json, the same file the nightly social post is built from.
 */
(function (root) {
  'use strict';

  // Same taste map as 31 Nights, so a tag means the same thing in both tools.
  var TASTES = {
    slasher: ['slasher'],
    supernatural: ['supernatural', 'possession'],
    found: ['found-footage'],
    folk: ['folk'],
    creature: ['creature', 'zombie', 'vampire', 'sci-fi'],
    psych: ['psychological'],
    comedy: ['comedy'],
    classic: ['classic'],
  };
  var ERAS = ['pre60', '1960s', '1970s', '1980s', '1990s', '2000s', '2010s', '2020s'];
  var eraOf = function (year) { return year < 1960 ? 'pre60' : Math.floor(year / 10) * 10 + 's'; };
  var LEVELS = { any: [1, 5], cozy: [1, 2], creepy: [1, 3], scary: [2, 4], nomercy: [3, 5] };
  var RANKS = [[31, 'Saint'], [21, 'Martyr'], [13, 'Devout'], [7, 'Novice'], [0, 'Sinner']];
  var FREE_PULLS = 4;   // the first card plus three re-pulls a day; the Congregation pulls without limit
  var MIN_POOL = 6;     // fewer than this and a re-pull starts handing back the same few films

  function rng(seed) { // mulberry32, same as 31 Nights
    var a = seed >>> 0;
    return function () {
      a = (a + 0x6d2b79f5) >>> 0;
      var t = Math.imul(a ^ (a >>> 15), 1 | a);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }

  function wantedTags(prefs) {
    var tastes = prefs.tastes && prefs.tastes.length ? prefs.tastes : Object.keys(TASTES);
    var tags = {};
    tastes.forEach(function (t) { (TASTES[t] || []).forEach(function (g) { tags[g] = 1; }); });
    if (prefs.level === 'cozy') tags.gateway = 1;
    return tags;
  }

  /* Decades and "under 90 minutes" are promises: no widening ever breaks them.
   * Taste, scare level and "skip the famous ones" are preferences, loosened one
   * notch at a time, and the result says which one gave so the page can say so. */
  function poolFor(films, prefs) {
    prefs = prefs || {};
    var band = LEVELS[prefs.level] || LEVELS.any;
    var tags = wantedTags(prefs);
    var anyTaste = !(prefs.tastes && prefs.tastes.length) && prefs.level !== 'cozy';
    var hasTag = function (f) { return anyTaste || f.g.some(function (g) { return tags[g]; }); };
    var inBand = function (f, pad) { return f.i >= band[0] - pad && f.i <= band[1] + (prefs.level === 'cozy' ? 0 : pad); };
    var eras = {}, anyEra = true;
    (prefs.eras || []).forEach(function (e) { if (ERAS.indexOf(e) >= 0) { eras[e] = 1; anyEra = false; } });
    var keep = function (f) { return !f.x && (anyEra || !!eras[eraOf(f.y)]) && (!prefs.short || f.rt <= 90); };
    var steps = [
      { note: '', test: function (f) { return hasTag(f) && inBand(f, 0) && !(prefs.skipSeen && f.f); } },
      { note: 'seen', test: function (f) { return hasTag(f) && inBand(f, 0); } },
      { note: 'band', test: function (f) { return hasTag(f) && inBand(f, 1); } },
      { note: 'any', test: function (f) { return inBand(f, 1); } },
    ];
    var pool = [];
    for (var s = 0; s < steps.length; s++) {
      pool = films.filter(function (f) { return keep(f) && steps[s].test(f); });
      if (pool.length >= MIN_POOL) return { pool: pool, widened: steps[s].note };
    }
    return { pool: pool, widened: 'any', empty: !pool.length };
  }

  // One card. Never one already pulled today while the pool has others left.
  function pull(films, prefs, seen, seed) {
    var got = poolFor(films, prefs);
    if (got.empty) return { error: 'empty' };
    var skip = {};
    (seen || []).forEach(function (n) { skip[n] = 1; });
    var fresh = got.pool.filter(function (f) { return !skip[f.n]; });
    var from = fresh.length ? fresh : got.pool;
    var film = from[Math.floor(rng(seed || 1)() * from.length)];
    return { n: film.n, widened: got.widened, recycled: !fresh.length };
  }

  var two = function (n) { return (n < 10 ? '0' : '') + n; };
  function dateKey(d) { return d.getFullYear() + '-' + two(d.getMonth() + 1) + '-' + two(d.getDate()); }
  function addDays(key, days) {
    var p = key.split('-');
    return dateKey(new Date(+p[0], +p[1] - 1, +p[2] + days));
  }
  // Before 4 AM still counts as last night: nobody wants a new card at 1 AM mid-film.
  function nightKey(now) { return dateKey(new Date(now.getTime() - 4 * 36e5)); }

  function hash(str) { var h = 2166136261; for (var i = 0; i < str.length; i++) { h ^= str.charCodeAt(i); h = Math.imul(h, 16777619); } return h >>> 0; }

  // The house card: one film for everybody tonight. The schedule file decides;
  // past its last date it falls back to a steady pick from the films with facts.
  function houseCard(daily, facts, films, key) {
    var days = (daily && daily.days) || {};
    if (days[key]) return days[key];
    var byN = index(films);
    var withFacts = Object.keys(facts || {}).map(Number).filter(function (n) { return byN[n] && !byN[n].x; }).sort(function (a, b) { return a - b; });
    var list = withFacts.length ? withFacts : films.filter(function (f) { return !f.x; }).map(function (f) { return f.n; });
    return list[hash(key) % list.length];
  }

  function index(films) { var m = {}; films.forEach(function (f) { m[f.n] = f; }); return m; }

  // Consecutive nights with a card, ending tonight (or last night, so a streak
  // does not look broken at breakfast).
  function streak(nights, today) {
    var have = {};
    (nights || []).forEach(function (k) { have[k] = 1; });
    var k = have[today] ? today : addDays(today, -1), count = 0;
    while (have[k]) { count++; k = addDays(k, -1); }
    return count;
  }

  function rank(count) {
    for (var i = 0; i < RANKS.length; i++) if (count >= RANKS[i][0]) return RANKS[i][1];
    return 'Sinner';
  }

  function pullsLeft(state, today) {
    if (state.member) return Infinity;
    var used = state.pulls && state.pulls.date === today ? state.pulls.count : 0;
    return Math.max(0, FREE_PULLS - used);
  }

  function roman(num) {
    var out = '', map = [[1000, 'M'], [900, 'CM'], [500, 'D'], [400, 'CD'], [100, 'C'], [90, 'XC'], [50, 'L'], [40, 'XL'], [10, 'X'], [9, 'IX'], [5, 'V'], [4, 'IV'], [1, 'I']];
    map.forEach(function (m) { while (num >= m[0]) { out += m[1]; num -= m[0]; } });
    return out;
  }

  // What a signup is tagged with, so the Friday email can be cut by taste.
  function signupTags(prefs) {
    var tags = ['tonight-2026'];
    prefs = prefs || {};
    (prefs.tastes || []).forEach(function (t) { if (TASTES[t]) tags.push('tn-taste-' + t); });
    if (prefs.level && prefs.level !== 'any' && LEVELS[prefs.level]) tags.push('tn-level-' + prefs.level);
    (prefs.eras || []).forEach(function (e) { if (ERAS.indexOf(e) >= 0) tags.push('tn-era-' + e); });
    if (prefs.short) tags.push('tn-short');
    if (prefs.skipSeen) tags.push('tn-deep-cuts');
    return tags;
  }

  // One box takes an email or a phone. US numbers only for texts.
  function contactOf(raw) {
    var v = String(raw || '').trim();
    if (/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) return { kind: 'email', value: v.toLowerCase() };
    var digits = v.replace(/[^\d]/g, '');
    if (/^[\d\s().+-]+$/.test(v)) {
      if (digits.length === 10 && /^[2-9]\d{2}[2-9]/.test(digits)) return { kind: 'phone', value: '+1' + digits };
      if (digits.length === 11 && digits[0] === '1' && /^1[2-9]\d{2}[2-9]/.test(digits)) return { kind: 'phone', value: '+' + digits };
      return { kind: 'bad-phone' };
    }
    return { kind: 'bad' };
  }

  var core = { TASTES: TASTES, LEVELS: LEVELS, ERAS: ERAS, FREE_PULLS: FREE_PULLS, MIN_POOL: MIN_POOL, eraOf: eraOf, poolFor: poolFor, pull: pull, dateKey: dateKey, addDays: addDays, nightKey: nightKey, houseCard: houseCard, streak: streak, rank: rank, pullsLeft: pullsLeft, roman: roman, signupTags: signupTags, contactOf: contactOf };
  if (typeof module !== 'undefined' && module.exports) { module.exports = core; return; }
  root.SSTonight = core;

  /* ---------------- the page ---------------- */

  var el = document.getElementById('sst');
  if (!el) return;
  var KEY = 'ss-tonight';
  var films = [], byN = {}, facts = {}, trivia = [], videos = {}, daily = {};
  var state = load();
  var current = null;   // { n, house, shared }
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var today = nightKey(new Date());

  function load() { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; } }
  function save() { try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (e) { /* private mode: nothing persists, the card still works */ } }
  function $(sel, from) { return (from || el).querySelector(sel); }
  function $$(sel, from) { return [].slice.call((from || el).querySelectorAll(sel)); }
  function h(tag, attrs, kids) {
    var node = document.createElement(tag);
    Object.keys(attrs || {}).forEach(function (k) {
      if (attrs[k] === false || attrs[k] == null) return;
      if (k === 'text') node.textContent = attrs[k];
      else if (k === 'html') node.innerHTML = attrs[k];
      else if (k.slice(0, 2) === 'on') node.addEventListener(k.slice(2), attrs[k]);
      else node.setAttribute(k, attrs[k] === true ? '' : attrs[k]);
    });
    (kids || []).forEach(function (kid) { if (kid) node.appendChild(typeof kid === 'string' ? document.createTextNode(kid) : kid); });
    return node;
  }
  function track(name, data) {
    data = data || {};
    // Pulls and shares also go to Meta from the server: Shopify's sandboxed custom
    // pixels lose most browser events. Same event_id both ways so Meta counts one.
    if (name === 'pull' || name === 'share') {
      data.event_id = data.event_id || 'sst-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
      try {
        fetch(String(el.getAttribute('data-endpoint')).replace(/\/join$/, '/event'), { method: 'POST', mode: 'no-cors', keepalive: true,
          headers: { 'Content-Type': 'text/plain' }, body: JSON.stringify({ name: name, event_id: data.event_id, page_url: location.href.split('#')[0], fbp: cookie('_fbp'), fbc: cookie('_fbc'), film: data.film || '' }) });
      } catch (e) { /* tracking never breaks the page */ }
    }
    try { if (root.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('ss_tonight_' + name, data); } catch (e) { /* analytics never breaks the page */ }
  }
  function utm() {
    var q = new URLSearchParams(location.search), out = {};
    ['source', 'medium', 'campaign', 'content'].forEach(function (k) { var v = q.get('utm_' + k); if (v) out[k] = v.slice(0, 80); });
    return out;
  }
  function cookie(name) { var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)')); return m ? decodeURIComponent(m[1]) : undefined; }

  var KIND = { slasher: 'Slasher', supernatural: 'Supernatural', possession: 'Possession', 'found-footage': 'Found footage', folk: 'Folk horror', creature: 'Creature feature',
    zombie: 'Zombie', vampire: 'Vampire', psychological: 'Psychological', comedy: 'Horror comedy', classic: 'Classic', 'sci-fi': 'Sci-fi horror', gateway: 'Gateway', anthology: 'Anthology', international: 'International' };

  // One sigil per kind of horror, drawn in the card's centre like a tarot emblem.
  var SIGILS = {
    slasher: '<path d="M50 10 L58 62 L50 70 L42 62 Z"/><path d="M36 70 H64"/><path d="M50 70 V92"/>',
    supernatural: '<path d="M50 14 C62 30 60 42 50 48 C40 42 38 30 50 14 Z"/><rect x="40" y="52" width="20" height="38" rx="2"/><path d="M34 90 H66"/>',
    possession: '<path d="M50 12 V88"/><path d="M30 34 H70"/><circle cx="50" cy="34" r="22"/>',
    'found-footage': '<rect x="18" y="34" width="46" height="34" rx="4"/><path d="M64 44 L84 34 V68 L64 58 Z"/><circle cx="32" cy="24" r="8"/><circle cx="52" cy="24" r="8"/>',
    folk: '<path d="M50 90 V40"/><path d="M50 52 C40 46 34 38 32 26"/><path d="M50 52 C60 46 66 38 68 26"/><path d="M50 40 C44 34 42 24 44 14"/><path d="M50 40 C56 34 58 24 56 14"/><path d="M38 34 L28 30"/><path d="M62 34 L72 30"/>',
    creature: '<path d="M30 18 L42 82"/><path d="M48 14 L56 86"/><path d="M66 18 L70 82"/>',
    zombie: '<path d="M30 30 C30 14 70 14 70 30 V58 C70 70 60 72 60 82 H40 C40 72 30 70 30 58 Z"/><circle cx="42" cy="44" r="6"/><circle cx="58" cy="44" r="6"/><path d="M44 82 V74 M50 82 V74 M56 82 V74"/>',
    vampire: '<path d="M18 36 C34 52 66 52 82 36"/><path d="M36 46 L40 68 L44 48"/><path d="M56 48 L60 68 L64 46"/>',
    'sci-fi': '<ellipse cx="50" cy="50" rx="36" ry="12"/><path d="M34 46 C34 26 66 26 66 46"/><path d="M40 62 L32 84 M60 62 L68 84"/>',
    psychological: '<path d="M12 50 C30 24 70 24 88 50 C70 76 30 76 12 50 Z"/><circle cx="50" cy="50" r="12"/><circle cx="50" cy="50" r="4"/>',
    comedy: '<path d="M22 30 C22 72 78 72 78 30 Z"/><path d="M34 44 C38 40 42 40 46 44"/><path d="M54 44 C58 40 62 40 66 44"/><path d="M36 54 C44 64 56 64 64 54"/>',
    classic: '<circle cx="50" cy="50" r="34"/><circle cx="50" cy="50" r="6"/><circle cx="50" cy="28" r="7"/><circle cx="50" cy="72" r="7"/><circle cx="28" cy="50" r="7"/><circle cx="72" cy="50" r="7"/>',
    other: '<path d="M62 16 A36 36 0 1 0 62 84 A28 28 0 1 1 62 16 Z"/>',
  };
  function sigil(film) {
    var key = SIGILS[film.g[0]] ? film.g[0] : (film.g.filter(function (g) { return SIGILS[g]; })[0] || 'other');
    return '<svg viewBox="0 0 100 100" aria-hidden="true" focusable="false">' + SIGILS[key] + '</svg>';
  }

  function halos(level) {
    var row = h('span', { class: 'sst-halos', role: 'img', 'aria-label': 'Scare ' + level + ' of 5' });
    for (var i = 1; i <= 5; i++) row.appendChild(h('i', { class: i <= level ? 'is-on' : '' }));
    return row;
  }

  // The relic is the back of the card: a sourced fact, or trivia while a film waits for one.
  function relic(film) {
    var fx = facts[film.n];
    if (fx && fx.fact && fx.source_url) {
      return h('div', { class: 'sst-relic' }, [
        h('p', { class: 'sst-relic__label', text: 'The Relic' }),
        h('p', { class: 'sst-relic__fact', text: fx.fact }),
        h('p', { class: 'sst-relic__src' }, ['Source: ', h('a', { href: fx.source_url, target: '_blank', rel: 'noopener nofollow', text: fx.source_name || 'see the source' })]),
      ]);
    }
    var t = trivia.length ? trivia[hash(String(film.n)) % trivia.length] : null;
    return h('div', { class: 'sst-relic' }, [
      h('p', { class: 'sst-relic__label', text: 'Horror trivia' }),
      t ? h('p', { class: 'sst-relic__fact', text: t.q }) : h('p', { class: 'sst-relic__fact', text: film.w }),
      t && h('details', { class: 'sst-relic__answer' }, [h('summary', { text: 'Show the answer' }), h('p', { text: t.a })]),
    ]);
  }

  function cardFor(film, label) {
    return h('div', { class: 'sst-card', 'data-card': film.n }, [
      h('div', { class: 'sst-card__inner' }, [
        h('div', { class: 'sst-card__face sst-card__front' }, [
          h('p', { class: 'sst-card__num', text: roman(film.n) }),
          h('p', { class: 'sst-card__label', text: label }),
          h('div', { class: 'sst-card__art' }, [h('div', { class: 'sst-card__sigil', html: sigil(film) })]),
          h('h2', { class: 'sst-card__title', text: film.t }),
          h('p', { class: 'sst-card__meta', text: film.y + ' · ' + film.rt + ' min · ' + film.d }),
          h('p', { class: 'sst-card__kind', text: film.g.map(function (g) { return KIND[g]; }).filter(Boolean).slice(0, 2).join(' · ') }),
          halos(film.i),
          h('p', { class: 'sst-card__why', text: film.w }),
        ]),
        h('div', { class: 'sst-card__face sst-card__back' }, [relic(film)]),
      ]),
    ]);
  }

  /* ---- filters ---- */

  function readPrefs() {
    return {
      tastes: $$('[name="sst-taste"]:checked').map(function (i) { return i.value; }),
      level: ($('[name="sst-level"]:checked') || {}).value || 'any',
      eras: $$('[name="sst-era"]:checked').map(function (i) { return i.value; }),
      short: !!($('[name="sst-short"]') || {}).checked,
      skipSeen: !!($('[name="sst-skip"]') || {}).checked,
    };
  }
  function writePrefs(p) {
    if (!p) return;
    $$('[name="sst-taste"]').forEach(function (i) { i.checked = (p.tastes || []).indexOf(i.value) >= 0; });
    $$('[name="sst-level"]').forEach(function (i) { i.checked = i.value === (p.level || 'any'); });
    $$('[name="sst-era"]').forEach(function (i) { i.checked = (p.eras || []).indexOf(i.value) >= 0; });
    if ($('[name="sst-short"]')) $('[name="sst-short"]').checked = !!p.short;
    if ($('[name="sst-skip"]')) $('[name="sst-skip"]').checked = !!p.skipSeen;
    $('[data-era-any]').checked = !(p.eras || []).length;
  }
  function countFilms() {
    if (!films.length) return;
    var got = poolFor(films, readPrefs());
    $('[data-era-any]').checked = !readPrefs().eras.length;
    var note = $('[data-pool]');
    note.textContent = got.empty ? 'Nothing in the library fits those decades and that runtime. Add a decade or untick under 90 minutes.'
      : got.widened ? got.pool.length + ' films in play (we loosened ' + ({ seen: 'the famous-film filter', band: 'the scare level by one notch', any: 'the mood' })[got.widened] + ' to find them).'
      : got.pool.length + ' films in play.';
    $('[data-act="pull"]').disabled = !!got.empty;
  }

  /* ---- pulling a card ---- */

  function pullCard() {
    var left = pullsLeft(state, today);
    if (left <= 0) { showJoin('limit'); return; }
    var prefs = readPrefs();
    state.prefs = prefs;
    var seenToday = (state.deck || []).filter(function (d) { return d.date === today; }).map(function (d) { return d.n; });
    var got = pull(films, prefs, seenToday, Math.floor(Math.random() * 1e9) + 1);
    if (got.error) { countFilms(); return; }
    state.pulls = { date: today, count: (state.pulls && state.pulls.date === today ? state.pulls.count : 0) + 1 };
    state.deck = (state.deck || []).concat([{ n: got.n, date: today }]).slice(-400);
    state.nights = uniq((state.nights || []).concat([today])).slice(-400);
    save();
    current = { n: got.n };
    track('pull', { film: byN[got.n].t, n: got.n, pull: state.pulls.count, tastes: prefs.tastes.join(','), level: prefs.level, widened: got.widened || '' });
    ritual(function () { reveal(got.n, 'Tonight’s Sacrifice'); });
  }
  function uniq(list) { var s = {}; return list.filter(function (k) { if (s[k]) return false; s[k] = 1; return true; }); }

  // Light the candles, shuffle the deck, flip the top card. About a second; none of it with reduced motion.
  function ritual(done) {
    var altar = $('[data-altar]');
    if (reduce) { done(); return; }
    altar.classList.remove('is-shuffling'); void altar.offsetWidth;
    altar.classList.add('is-lit', 'is-shuffling');
    setTimeout(function () { altar.classList.remove('is-shuffling'); done(); }, 900);
  }

  function reveal(n, label, opts) {
    opts = opts || {};
    var film = byN[n];
    if (!film) return;
    var stage = $('[data-stage]');
    var card = cardFor(film, label);
    stage.replaceChildren(card);
    el.classList.add('has-card');
    if (!reduce && !opts.instant) { card.classList.add('is-down'); requestAnimationFrame(function () { requestAnimationFrame(function () { card.classList.remove('is-down'); }); }); }
    acts(film, opts);
    $('[data-banner]').hidden = !opts.banner;
    if (opts.banner) $('[data-banner]').textContent = opts.banner;
    draw();
    if (!opts.instant) {
      $('[data-reveal]').scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      var title = $('.sst-card__title', card); title.setAttribute('tabindex', '-1'); title.focus({ preventScroll: true });
    }
  }

  function acts(film, opts) {
    var box = $('[data-acts]');
    var left = pullsLeft(state, today);
    var vid = videos[film.n];
    box.replaceChildren.apply(box, [
      h('a', { class: 'sst-btn', href: 'https://www.justwatch.com/us/search?q=' + encodeURIComponent(film.t), target: '_blank', rel: 'noopener nofollow',
        onclick: function () { track('watch', { film: film.t, n: film.n }); }, text: 'Where to watch' }),
      h('button', { type: 'button', class: 'sst-btn sst-btn--ghost', 'data-turn': true, onclick: turn, text: 'Turn the card' }),
      opts.shared ? h('button', { type: 'button', class: 'sst-btn sst-btn--ghost', onclick: function () { history.replaceState(null, '', location.pathname); pullCard(); }, text: 'Pull my own card' })
        : h('button', { type: 'button', class: 'sst-btn sst-btn--ghost', onclick: pullCard,
          text: state.member ? 'Pull another' : left > 0 ? 'Pull another (' + left + ' left tonight)' : 'Pull another' }),
      h('button', { type: 'button', class: 'sst-btn sst-btn--ghost', onclick: function () { share(film); }, text: 'Share my card' }),
      !state.member && h('button', { type: 'button', class: 'sst-link sst-acts__join', onclick: function () { showJoin(); $('[data-join]').scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); track('join_link', {}); }, text: 'Get the weekend pick every Friday →' })
    ].filter(Boolean));   // replaceChildren would print a skipped (false) entry as the word "false"
    var more = $('[data-video]');
    more.replaceChildren();
    more.hidden = !vid;
    if (vid) {
      // A theory title can give the twist away, so those show no title, only a warning.
      more.appendChild(h('p', { class: 'sst-eyebrow', text: vid.spoiler ? 'We made a video on this one. Spoilers, so watch the film first' : 'We made a video on this one' }));
      more.appendChild(h('a', { class: 'sst-video__link', href: vid.url, target: '_blank', rel: 'noopener', onclick: function () { track('video', { film: film.t, n: film.n }); }, text: (vid.spoiler ? 'Watch it after the film' : vid.title) + ' ↗' }));
      more.appendChild(h('a', { class: 'sst-link', href: el.getAttribute('data-youtube') + '?sub_confirmation=1', target: '_blank', rel: 'noopener', onclick: function () { track('subscribe', { from: 'video' }); }, text: 'Subscribe on YouTube' }));
    }
  }

  function turn() {
    var card = $('[data-stage] .sst-card');
    if (!card) return;
    var flipped = card.classList.toggle('is-turned');
    var btn = $('[data-turn]');
    if (btn) btn.textContent = flipped ? 'Turn it back' : 'Turn the card';
    if (flipped) track('relic', { n: +card.getAttribute('data-card') });
  }

  /* ---- the Congregation (signup) ---- */

  function showJoin(why) {
    var box = $('[data-join]');
    box.hidden = false;
    box.classList.toggle('is-limit', why === 'limit');
    if (why === 'limit') {
      $('[data-join-head]').textContent = 'That was your last free pull tonight';
      box.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    }
  }

  function phoneMode(on) {
    var sms = $('[data-sms]');
    sms.hidden = !on;
    $('[data-email-fine]').hidden = !!on;
    $('[name="sst-sms"]').required = !!on;
  }

  function submitJoin(e) {
    e.preventDefault();
    var form = e.target, err = $('[data-join-error]'), btn = $('button[type="submit"]', form);
    var c = contactOf($('[name="sst-contact"]', form).value);
    var smsBox = $('[name="sst-sms"]', form);
    err.hidden = true;
    if (c.kind === 'bad' || c.kind === 'bad-phone') {
      err.textContent = c.kind === 'bad-phone' ? 'That phone number does not look right. Use a 10 digit US number, or your email instead.' : 'Enter an email address or a US mobile number.';
      err.hidden = false; return;
    }
    if (c.kind === 'phone' && !smsBox.checked) { err.textContent = 'Tick the box so we are allowed to text you, or use your email instead.'; err.hidden = false; return; }
    var eventId = 'sst-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
    var body = {
      source: 'tonight', event_id: eventId, utm: utm(), page_url: location.href.split('#')[0],
      tags: signupTags(state.prefs).concat(c.kind === 'phone' ? ['tn-sms'] : []),
      sms_consent: c.kind === 'phone' && smsBox.checked,
      consent_text: c.kind === 'phone' ? $('[data-sms-text]').textContent.replace(/\s+/g, ' ').trim() : '',
      fbp: cookie('_fbp'), fbc: cookie('_fbc'), website: $('[name="website"]', form).value,
    };
    body[c.kind] = c.value;
    btn.disabled = true; btn.textContent = 'Joining…';
    fetch(el.getAttribute('data-endpoint'), { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().catch(function () { return { ok: false }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.error || 'failed');
        state.member = true; state.joined = state.joined || today; state.via = c.kind;
        save();
        track('lead', { event_id: eventId, method: c.kind, film: current ? byN[current.n].t : '' });
        joined(c.kind);
        if (current) acts(byN[current.n], {});
        draw();
      })
      .catch(function (x) {
        err.textContent = x.message === 'phone' ? 'That phone number did not work. Try your email instead.' : 'That did not go through. Try again in a minute.';
        err.hidden = false;
      })
      .then(function () { btn.disabled = false; btn.textContent = 'Join the Congregation'; });
  }

  function joined(kind) {
    var box = $('[data-join]');
    box.classList.add('is-member');
    $('[data-join-head]').textContent = 'Welcome to the Congregation';
    $('[data-join-text]').textContent = kind === 'phone'
      ? 'You are in. Unlimited pulls are unlocked and your deck is below. The Friday text starts soon, and we will send a welcome text first.'
      : 'Your first Weekend Sacrifice lands Friday. Unlimited pulls are unlocked, and your deck is below.';
    $('[data-join-form]').hidden = true;
  }

  /* ---- deck, streak, the morning-after question ---- */

  function draw() {
    var deck = state.deck || [];
    var count = streak(state.nights, today);
    $('[data-streak]').textContent = String(count);
    $('[data-rank]').textContent = rank(count);
    $('[data-cards]').textContent = String(uniq(deck.map(function (d) { return d.n; })).length);
    $('[data-stats]').hidden = !deck.length;
    if (deck.length && !state.member) $('[data-join]').hidden = false;
    if (state.member) joined(state.via);

    var list = $('[data-deck]');
    list.replaceChildren();
    $('[data-deck-wrap]').hidden = !(state.member && deck.length);
    if (state.member) {
      var shown = {};
      deck.slice().reverse().forEach(function (d) {
        if (shown[d.n] || !byN[d.n]) return; shown[d.n] = 1;
        var f = byN[d.n], vote = (state.rated || {})[d.n];
        list.appendChild(h('li', {}, [
          h('button', { type: 'button', class: 'sst-deck__card', onclick: function () { current = { n: d.n }; reveal(d.n, 'From your deck'); }, 'aria-label': 'Show ' + f.t }, [
            h('span', { class: 'sst-deck__num', text: roman(f.n) }), h('b', { text: f.t }), h('span', { text: f.y + (vote ? (vote > 0 ? ' · loved it' : ' · not for me') : '') }),
          ]),
        ]));
      });
    }
    ask();
  }

  // The morning after: did you watch last night's card? It is the taste data
  // the merch is designed from, and a reason to come back.
  function ask() {
    var box = $('[data-ask]');
    var last = (state.deck || []).filter(function (d) { return d.date < today && !((state.rated || {})[d.n]); }).pop();
    box.hidden = !last || state.asked === today;
    if (box.hidden) return;
    var f = byN[last.n];
    if (!f) { box.hidden = true; return; }
    box.replaceChildren(
      h('p', { text: 'Did you watch ' }, [h('b', { text: f.t }), document.createTextNode('?')]),
      h('div', { class: 'sst-ask__acts' }, [
        h('button', { type: 'button', class: 'sst-btn sst-btn--small', onclick: function () { rate(f, 1); }, text: 'Loved it' }),
        h('button', { type: 'button', class: 'sst-btn sst-btn--small sst-btn--ghost', onclick: function () { rate(f, -1); }, text: 'Not for me' }),
        h('button', { type: 'button', class: 'sst-link', onclick: function () { state.asked = today; save(); ask(); }, text: 'Did not watch it' }),
      ])
    );
  }
  function rate(film, vote) {
    state.rated = state.rated || {}; state.rated[film.n] = vote; state.asked = today; save();
    track('rate', { film: film.t, n: film.n, vote: vote > 0 ? 'up' : 'down' });
    draw();
  }

  /* ---- share: a Story-sized image of the card ---- */

  function wrap(x, text, max) {
    var words = String(text).split(' '), lines = [], line = '';
    words.forEach(function (w) { var t = line ? line + ' ' + w : w; if (x.measureText(t).width > max && line) { lines.push(line); line = w; } else line = t; });
    if (line) lines.push(line);
    return lines;
  }

  function cardImage(film) {
    var W = 1080, H = 1920, c = document.createElement('canvas'); c.width = W; c.height = H;
    var x = c.getContext('2d');
    var head = '"Bebas Neue", "Arial Narrow", Impact, sans-serif', body = 'Inter, "Helvetica Neue", Arial, sans-serif';
    x.fillStyle = '#060607'; x.fillRect(0, 0, W, H);
    var glow = x.createRadialGradient(W / 2, 760, 40, W / 2, 760, 900);
    glow.addColorStop(0, 'rgba(193,18,31,.55)'); glow.addColorStop(1, 'rgba(0,0,0,0)');
    x.fillStyle = glow; x.fillRect(0, 0, W, H);
    // the card: Instagram covers the top 250 and bottom 260, so everything sits between
    var cx = 150, cy = 270, cw = 780, ch = 1180;
    x.fillStyle = '#0d0c0e'; x.fillRect(cx, cy, cw, ch);
    x.strokeStyle = 'rgb(240,222,170)'; x.lineWidth = 6; x.strokeRect(cx + 14, cy + 14, cw - 28, ch - 28);
    x.lineWidth = 2; x.strokeRect(cx + 30, cy + 30, cw - 60, ch - 60);
    x.textAlign = 'center'; x.fillStyle = 'rgb(240,222,170)';
    x.font = '400 64px ' + head; x.fillText(roman(film.n), W / 2, cy + 120);
    x.fillStyle = 'rgb(255,92,104)'; x.font = '700 26px ' + body; x.fillText('TONIGHT’S SACRIFICE', W / 2, cy + 170);
    // sigil
    var img = new Image(), svg = sigil(film).replace('<svg ', '<svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="rgb(255,205,96)" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" ');
    return new Promise(function (resolve) {
      img.onload = function () { x.drawImage(img, W / 2 - 150, cy + 210, 300, 300); finish(); };
      img.onerror = finish;
      img.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg);
      function finish() {
        x.fillStyle = 'rgb(240,222,170)';
        var size = 120; x.font = '400 ' + size + 'px ' + head;
        var lines = wrap(x, film.t.toUpperCase(), cw - 120);
        while (lines.length > 3 && size > 70) { size -= 10; x.font = '400 ' + size + 'px ' + head; lines = wrap(x, film.t.toUpperCase(), cw - 120); }
        var y = cy + 600;
        lines.forEach(function (l) { x.fillText(l, W / 2, y); y += size * 0.92; });
        x.fillStyle = 'rgba(234,230,222,.85)'; x.font = '500 30px ' + body;
        x.fillText(film.y + '  ·  ' + film.rt + ' MIN  ·  SCARE ' + film.i + ' OF 5', W / 2, y + 30);
        for (var i = 0; i < 5; i++) {
          x.beginPath(); x.ellipse(W / 2 - 160 + i * 80, y + 100, 28, 10, 0, 0, Math.PI * 2);
          x.strokeStyle = i < film.i ? 'rgb(255,205,96)' : 'rgba(234,230,222,.25)'; x.lineWidth = 5; x.stroke();
        }
        var fx = facts[film.n];
        x.fillStyle = 'rgba(234,230,222,.9)'; x.font = '400 30px ' + body;
        var why = wrap(x, fx && fx.fact ? fx.fact : film.w, cw - 160).slice(0, 5), wy = y + 190;
        if (fx && fx.fact) { x.fillStyle = 'rgb(255,92,104)'; x.font = '700 22px ' + body; x.fillText('THE RELIC', W / 2, wy - 46); x.fillStyle = 'rgba(234,230,222,.9)'; x.font = '400 30px ' + body; }
        why.forEach(function (l) { x.fillText(l, W / 2, wy); wy += 42; });
        x.fillStyle = 'rgb(240,222,170)'; x.font = '400 54px ' + head; x.fillText('PULL YOURS', W / 2, 1560);
        x.fillStyle = 'rgba(234,230,222,.8)'; x.font = '600 30px ' + body; x.fillText('screamingsaints.com/tonight', W / 2, 1610);
        resolve(c);
      }
    });
  }

  function share(film) {
    var url = location.origin + '/pages/tonight?card=' + film.n + '&utm_source=share&utm_medium=card';
    var text = 'Tonight’s Sacrifice: ' + film.t + ' (' + film.y + '). Pull yours.';
    track('share', { film: film.t, n: film.n });
    var fonts = document.fonts && document.fonts.load ? Promise.all([document.fonts.load('400 100px "Bebas Neue"'), document.fonts.load('400 30px Inter')]).catch(function () {}) : Promise.resolve();
    fonts.then(function () { return cardImage(film); }).then(function (c) {
      c.toBlob(function (blob) {
        var file = blob && typeof File !== 'undefined' ? new File([blob], 'tonights-sacrifice.png', { type: 'image/png' }) : null;
        if (file && navigator.canShare && navigator.canShare({ files: [file] })) {
          navigator.share({ files: [file], text: text + ' ' + url }).catch(function () {});
        } else if (navigator.share) {
          navigator.share({ title: 'Tonight’s Sacrifice', text: text, url: url }).catch(function () {});
          download(blob);
        } else {
          download(blob);
          try { navigator.clipboard.writeText(text + ' ' + url); } catch (e) { /* the image still downloaded */ }
        }
      }, 'image/png');
    });
  }
  function download(blob) {
    if (!blob) return;
    var a = h('a', { href: URL.createObjectURL(blob), download: 'tonights-sacrifice.png' });
    document.body.appendChild(a); a.click(); setTimeout(function () { URL.revokeObjectURL(a.href); a.remove(); }, 1000);
  }

  /* ---- the house card ---- */

  function showHouse() {
    var n = houseCard(daily, facts, films, today), f = byN[n];
    var box = $('[data-house]');
    if (!f) { box.hidden = true; return; }
    box.hidden = false;
    $('[data-house-title]').textContent = f.t + ' (' + f.y + ')';
    $('[data-house-open]').onclick = function () { current = { n: n, house: true }; track('house', { film: f.t, n: n }); reveal(n, 'The House Card'); };
  }

  /* ---- start ---- */

  function start() {
    writePrefs(state.prefs);
    $$('[name="sst-taste"], [name="sst-level"], [name="sst-era"], [name="sst-short"], [name="sst-skip"]').forEach(function (i) { i.addEventListener('change', countFilms); });
    $('[data-era-any]').addEventListener('change', function (e) { if (e.target.checked) $$('[name="sst-era"]').forEach(function (i) { i.checked = false; }); countFilms(); });
    $('[data-act="pull"]').addEventListener('click', pullCard);
    $('[data-join-form]').addEventListener('submit', submitJoin);
    $('[name="sst-contact"]').addEventListener('input', function (e) { var k = contactOf(e.target.value).kind; phoneMode(k === 'phone' || k === 'bad-phone'); $('[data-join-error]').hidden = true; });
    countFilms();
    showHouse();
    draw();

    var q = new URLSearchParams(location.search);
    var shared = parseInt(q.get('card'), 10);
    if (byN[shared]) {
      current = { n: shared, shared: true };
      track('shared_open', { film: byN[shared].t, n: shared });
      reveal(shared, q.get('house') ? 'The House Card' : 'A card pulled for you', { instant: true, shared: true, banner: q.get('house') ? 'Tonight the whole Congregation is watching this one.' : 'Somebody pulled this card and sent it to you.' });
      return;
    }
    // Back the same night: the last card is still on the altar, no ritual.
    var mine = (state.deck || []).filter(function (d) { return d.date === today; }).pop();
    if (mine && byN[mine.n]) { current = { n: mine.n }; reveal(mine.n, 'Tonight’s Sacrifice', { instant: true }); }
  }

  function getJSON(attr, fallback) {
    var url = el.getAttribute(attr);
    if (!url) return Promise.resolve(fallback);
    return fetch(url).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); }).catch(function () { return fallback; });
  }

  Promise.all([getJSON('data-films', null), getJSON('data-facts', {}), getJSON('data-daily', {}), getJSON('data-videos', {})]).then(function (all) {
    if (!all[0] || !all[0].length) { $('[data-error]').hidden = false; $('[data-act="pull"]').disabled = true; return; }
    films = all[0]; byN = index(films);
    facts = (all[1] && all[1].films) || {}; trivia = (all[1] && all[1].trivia) || [];
    daily = all[2] || {}; videos = (all[3] && all[3].films) || {};
    el.classList.add('is-ready');
    start();
  });
})(typeof window !== 'undefined' ? window : this);
